import * as gtag from "utils/gtag"; 
export const handlerClickConfiguration = (router) => {
  gtag.event({
    action: "click",
    category: "efficient-purchase",
    label: "button__config",
    value: 0,
  });
  router.push(`/${router.query.clientId}/settings/POS`);
}